import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names, letting later classes win over earlier ones.
 *
 * clsx flattens the conditional/array/object forms; twMerge then resolves
 * conflicts within the same utility group, so a caller passing `bg-red-500`
 * overrides a component's built-in `bg-sidebar` rather than both landing in the
 * class list and the winner being decided by stylesheet order.
 *
 * Used by every component under frontend/components/ui. Note this is Tailwind
 * only -- it knows nothing about the Bootstrap classes used elsewhere in the
 * app, and will not deduplicate them.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
